import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');

const Component = videojs.getComponent('Component');

const Button = videojs.getComponent('MenuButton');

const defaults = {
  items: ['AudioTrackButton', 'SubsCapsButton', 'PlaybackRateMenuButton', 'RatesButton'],
  languages: {
    settings: 'Configurações',
    loading: 'Carregando',
    back: 'Voltar',
    subtitles_off: 'Legendas desativadas',
    subtitles: 'Legendas ativadas',
    captions_off: 'Legendas desativadas',
    "captions off": 'Legendas desativadas',
    captions: 'Legendas ativadas',
    default_audio: 'Áudio padrão',
    audio: 'Áudio',
    chapters: 'Capítulos',
    speed: 'Velocidade',
    quality: 'Qualidade',
  },
};

class SettingsMenu extends Plugin {
  constructor(player, options) {
    super(player);

    const self = this;

    self.playerId = this.player.id();

    this.options = {...defaults, ...options};

    this.player.ready(() => {
      this.player.addClass('vjs-settings-menu');
      this.buildUI();
    });

    // Listen to the event from the bitrate switcher
    this.player.on('playbackRateSwitched', function (e) {
      let rate = e.target.player.playbackRateSwitched;
      this.getChild('controlBar')
        .getChild('settingsMenuButton')
        .controlText(`${rate.height}p, ${self.formatBps(rate.bitrate)}`);
    });

    const menus = document.getElementById(self.playerId).querySelectorAll('.vjs-menu');
    this.player.on('userinactive', function () {
      menus.forEach(element => {
        element.classList.remove('vjs-lock-open');
      });
    });

    this.player.on('click', function (evt) {
      if (evt.target.classList.contains('vjs-play-control')) {
        return;
      }

      if (!evt.target.classList.contains('scaleup-settings-menu')
       && !evt.target.classList.contains('vjs-subs-caps-button')
       && !evt.target.classList.contains('scaleup-ai')
       && !evt.target.classList.contains('scaleup-ai-button')) {
        document
          .getElementById(self.playerId)
          .querySelectorAll('.vjs-menu')
          .forEach(element => {
            element.classList.remove('vjs-lock-showing');
            element.classList.remove('vjs-lock-open');
            this.el().classList.toggle('vjs-toogle-btn');
          });

        return;
      }

      let types = '';

      if (evt.target.classList.contains('scaleup-settings-menu')) {
        types = 'div.vjs-menu-button.vjs-subs-caps-button, div.vjs-menu-button.scaleup-ai';
      } else if (evt.target.classList.contains('vjs-subs-caps-button')) {
        types = 'div.vjs-menu-button.scaleup-settings-menu, div.vjs-menu-button.scaleup-ai';
      } else if (evt.target.classList.contains('scaleup-ai')
              || evt.target.classList.contains('scaleup-ai-button')) {
        types = 'div.vjs-menu-button.vjs-subs-caps-button, div.vjs-menu-button.scaleup-settings-menu';
      }

      console.log('types', types);

      let removeAnother = false;

      if (types) {
        document
          .querySelectorAll(types)
          .forEach(baseElement => {
            baseElement.querySelectorAll('[aria-expanded="true"]')
              .forEach(element => {
                element.setAttribute('aria-expanded', 'false');
              });

            baseElement.querySelectorAll('.vjs-menu')
              .forEach(element => {
                if (element.classList.contains('vjs-lock-showing')
                || element.classList.contains('vjs-lock-open')) {
                  removeAnother = true;
                }

                if (element.classList.contains('vjs-lock-showing')) {
                  element.classList.add('vjs-hidden');
                }

                element.classList.remove('vjs-lock-showing');
                element.classList.remove('vjs-lock-open');
                this.el().classList.toggle('vjs-toogle-btn');
              });
          })
      }

      if (removeAnother && types === 'div.vjs-menu-button.scaleup-settings-menu, div.vjs-menu-button.scaleup-ai') {
        evt.target.parentNode.querySelectorAll('[aria-expanded="false"]')
          .forEach(element => {
            element.setAttribute('aria-expanded', 'true');

            evt.target.parentNode.querySelectorAll('.vjs-menu')
            .forEach(element => {
              element.classList.remove('vjs-hidden');
              element.classList.add('vjs-lock-showing');
              element.classList.add('vjs-lock-open');
              this.el().classList.toggle('vjs-toogle-btn');
            });
          });
      }
    });

    this.player.on('loadstart', function (_event) {
      this.one('canplaythrough', function (_evt) {
        self.removeElementsByClass('vjs-setting-menu-clear');

        self.buildTopLevelMenu();
      });
    });
  }

  buildUI() {
    const self = this;

    class SettingsMenuButton extends Button {
      constructor(player, options) {
        super(player, options);
        this.addClass('vjs-settings-menu');
        this.addClass('scaleup-settings-menu');

        this.controlText(self.options.languages.loading);

        let that = this;

        self.player.one('canplaythrough', function (_event) {
          that.controlText(self.options.languages.settings);
        });
        this.menu.contentEl_.id = self.playerId + '-vjs-settings-menu-default';
        this.menuButton_.el().classList.add('scaleup-settings-menu');
        this.menu.el().classList.add('scaleup-settings-menu');
      }
      handleClick() {
        this.el().classList.toggle('vjs-toogle-btn');
        this.menu.el().classList.toggle('vjs-lock-open');
      }
    }
    videojs.registerComponent('settingsMenuButton', SettingsMenuButton);

    this.player.getChild('controlBar').addChild('settingsMenuButton');

    const menuButtonIcon = document.createElement('i');
    menuButtonIcon.className = 'fa-solid fa-gear';

    const settingsMenuButtonEl = this.player.getChild('controlBar').getChild('settingsMenuButton');

    videojs.dom.prependTo(menuButtonIcon, settingsMenuButtonEl.el());

    if (this.player.getChild('controlBar').getChild('pictureInPictureToggle')) {
      this.player
        .getChild('controlBar')
        .el()
        .insertBefore(
          this.player.getChild('controlBar').getChild('settingsMenuButton').el(),
          this.player.getChild('controlBar').getChild('pictureInPictureToggle').el(),
        );
    } else {
      this.player
        .getChild('controlBar')
        .el()
        .insertBefore(
          this.player.getChild('controlBar').getChild('settingsMenuButton').el(),
          this.player.getChild('controlBar').getChild('fullscreenToggle').el(),
        );
    }
  }

  buildTopLevelMenu() {
    const self = this;

    const settingsButton = self.player.getChild('controlBar').getChild('settingsMenuButton');

    const captionsButton = self.player.getChild('controlBar').getChild('subsCapsButton');

    if (captionsButton && captionsButton.items && captionsButton.items.length > 0) {

      captionsButton.items.forEach(item => {
        const current = item.el();

        if ((current.querySelector('.vjs-menu-item-text').innerText).toString().indexOf('captions') > -1) {
          current.querySelector('.vjs-menu-item-text').innerHTML = self.options.languages.subtitles_off;
        }

        let vjsMenuIcon = document.createElement('i');
        vjsMenuIcon.className = 'fa-solid fa-check';

        if (current.getElementsByClassName('scaleup-item__icon-wrapper').length === 0) {
          let vjsMenuItemIconWrapper = document.createElement('div');
          vjsMenuItemIconWrapper.className = 'scaleup-item__icon-wrapper';
          vjsMenuItemIconWrapper.appendChild(vjsMenuIcon);
          current.insertBefore(vjsMenuItemIconWrapper, current.firstChild);
        }
      });
    }

    const menu = settingsButton.menu;

    const main = settingsButton.menu.contentEl_;

    main.textContent = '';

    main.classList.add('scaleup-sm-top-level');

    let comps = [];
    let audio = false;
    let chapter = false;
    let subtitles = false;
    let qualities = false;
    if (self.player.textTracks().tracks_ || self.player.audioTracks().tracks_.length > 1) {
      if (self.player.audioTracks().tracks_.length > 1) {
        audio = true;
      }
      self.player.textTracks().tracks_.forEach(ele => {
        if (ele.kind === 'chapters') {
          chapter = true;
        }
        if (ele.kind === 'subtitles' || ele.kind === 'captions') {
          subtitles = true;
        }
      });
    }

    console.log('qualityLevels', self.player.qualityLevels());

    if (self.player.qualityLevels()) {
      qualities = true;
    }
    if (!audio) {
      comps.push('AudioTrackButton');
    }
    if (!chapter) {
      comps.push('ChaptersButton');
    }
    if (!subtitles) {
      comps.push('SubsCapsButton');
    }
    if (!qualities) {
      comps.push('QualityButton');
    }

    self.options.items
      .filter(item => !comps.includes(item))
      .map(async component => {
        if (self.player.getChild('controlBar').getChild(component)) {
          let textContent = self.setInitialStates(component);

          const fragment = document.createDocumentFragment();
          let settingItem = document.createElement('li');
          settingItem.setAttribute('data-component', component.toLowerCase());
          settingItem.className = 'scaleup-list-item';

          let settingLeftItemWrapper = document.createElement('div');
          settingLeftItemWrapper.className = 'scaleup-list-item__left-wrapper';
          settingItem.appendChild(settingLeftItemWrapper);

          let settingLeftItemSpan = document.createElement('span');
          settingLeftItemSpan.className = 'scaleup-list-item__left-wrapper__span';
          settingLeftItemSpan.innerText = textContent.language;
          settingLeftItemWrapper.appendChild(settingLeftItemSpan);

          fragment.appendChild(settingItem);
          main.appendChild(fragment);

          let settingRightItemWrapper = document.createElement('div');
          settingRightItemWrapper.className = 'scaleup-list-item__right-wrapper';
          settingItem.appendChild(settingRightItemWrapper);

          let settingRightItemSpan = document.createElement('span');
          settingRightItemSpan.id = self.playerId + '-setting-menu-child-span-' + component.toLowerCase();
          settingRightItemSpan.className = 'scaleup-list-item__right-wrapper__span';
          settingRightItemSpan.innerText = textContent.default;
          settingRightItemWrapper.appendChild(settingRightItemSpan);

          let settingRightItemIconWrapper = document.createElement('div');
          settingRightItemIconWrapper.className = 'scaleup-list-item__right-wrapper__icon';

          let settingRightItemIcon = document.createElement('i');
          settingRightItemIcon.className = 'fa-solid fa-chevron-right';
          settingRightItemIconWrapper.appendChild(settingRightItemIcon);
          settingRightItemWrapper.appendChild(settingRightItemIconWrapper);

          main.appendChild(settingItem);

          // Nasty little hack for chapters buttons as it seems to load after the canplay event
          await new Promise(resolve =>
            setTimeout(resolve, component === 'ChaptersButton' ? 1000 : 0, component === 'QualityButton' ? 1000 : 0),
          );
          self.buildMenuList(component);
        }
      });

    let settingMenuItems = document.querySelectorAll('.scaleup-settings-menu .scaleup-list-item');

    Array.from(settingMenuItems).forEach(link => {
      link.addEventListener('click', function (event) {
        document.querySelectorAll('.scaleup-sm-top-level').forEach(element => {
          element.classList.add('vjs-hidden');
        });

        let active = document.getElementById(
          self.playerId + '-setting-menu-child-menu-' + this.getAttribute('data-component'),
        );

        active.classList.remove('vjs-hidden');

        active.classList.add('vjs-lock');

        event.preventDefault();
      });
    });
  }

  buildMenuList(component) {
    const self = this;
    let textContent = self.setInitialStates(component);

    let settingsButton = this.player.getChild('controlBar').getChild('settingsMenuButton');

    // First check if component exists
    if (this.player.getChild('controlBar').getChild(component)) {
      let componentMenu = this.player.getChild('controlBar').getChild(component).menu.contentEl_;

      // Need some logic here to prevent back button showing multiple times
      for (let i = 0; i < componentMenu.children.length; i++) {
        let classCheck = componentMenu.children[i].getAttribute('class');
        if (classCheck === 'scaleup-setting-menu-header' || classCheck === 'vjs-menu-title') {
          componentMenu.children[i].remove();
        }
      }

      componentMenu.id = self.playerId + '-setting-menu-child-menu-' + component.toLowerCase();

      componentMenu.classList.add('vjs-hidden');
      componentMenu.classList.add('scaleup-settings-menu');
      componentMenu.classList.add('vjs-setting-menu-clear');

      let backBtn = document.createElement('li');

      backBtn.className = 'scaleup-setting-menu-header';

      backBtn.setAttribute('data-component', component.toLowerCase());

      let settingLeftHeaderWrapper = document.createElement('div');
      settingLeftHeaderWrapper.className = 'scaleup-setting-menu-header__left-wrapper';
      backBtn.appendChild(settingLeftHeaderWrapper);

      backBtn.onclick = function (_evt) {
        let set_state = document
          .getElementById(self.playerId + '-setting-menu-child-menu-' + this.getAttribute('data-component'))
          .querySelectorAll('.vjs-selected');
        if (set_state !== undefined && set_state.length > 0) {
          if (set_state[0].textContent) {
            document.getElementById(
              self.playerId + '-setting-menu-child-span-' + this.getAttribute('data-component'),
            ).innerText = self.cleanDefault(set_state[0].textContent);
          }
        }

        document.querySelectorAll('.scaleup-sm-top-level').forEach(element => {
          element.classList.remove('vjs-hidden');
        });

        document.querySelectorAll('.vjs-menu-content').forEach(element => {
          if (element.classList.value.includes('vjs-lock')) {
            element.classList.remove('vjs-lock');
            element.classList.add('vjs-hidden');
          }
        });
      };

      this.player.on('resize', () => {
        let set_state = document
          .getElementById(self.playerId + '-setting-menu-child-menu-qualitybutton')
          .querySelectorAll('.vjs-selected');
        if (set_state !== undefined && set_state.length > 0) {
          if (set_state[0].textContent) {
            document.getElementById(self.playerId + '-setting-menu-child-span-qualitybutton').innerText =
              self.cleanDefault(set_state[0].textContent);
          }
        }
      });

      let settingLeftHeaderIcon = document.createElement('div');
      settingLeftHeaderIcon.className = 'scaleup-setting-menu-header__icon';

      let settingLeftHeaderIconContent = document.createElement('i');
      settingLeftHeaderIconContent.className = 'fa-solid fa-chevron-left';
      settingLeftHeaderIcon.appendChild(settingLeftHeaderIconContent);

      settingLeftHeaderWrapper.appendChild(settingLeftHeaderIcon);

      let settingLeftHeaderSpan = document.createElement('span');
      settingLeftHeaderSpan.className = 'scaleup-setting-menu-header__span';
      settingLeftHeaderSpan.innerText = textContent.language;
      settingLeftHeaderWrapper.appendChild(settingLeftHeaderSpan);

      componentMenu.insertBefore(backBtn, componentMenu.firstChild);

      settingsButton.menu.el().appendChild(componentMenu);

      let menuItems = componentMenu.querySelectorAll('.vjs-menu-item');
      menuItems.forEach(item => {
        let vjsMenuIcon = document.createElement('i');
        vjsMenuIcon.className = 'fa-solid fa-check';

        if (item.getElementsByClassName('scaleup-item__icon-wrapper').length === 0) {
          let vjsMenuItemIconWrapper = document.createElement('div');
          vjsMenuItemIconWrapper.className = 'scaleup-item__icon-wrapper';
          vjsMenuItemIconWrapper.appendChild(vjsMenuIcon);
          item.insertBefore(vjsMenuItemIconWrapper, item.firstChild);
        }
      });

      if (component === 'PlaybackRateMenuButton') {
        let playbackDefaultState = document
          .getElementById(self.playerId + '-setting-menu-child-menu-playbackratemenubutton')
          .querySelectorAll('.vjs-selected');

        playbackDefaultState[0].childNodes.forEach(playbackRate => {
          if (playbackRate.innerText === '1x') {
            playbackRate.innerText = 'Normal';
          }
        });
      }
    }
  }

  setInitialStates(component) {
    switch (component) {
      case 'QualityButton':
        return {
          default: this.player.tech(true).vhs.playlists.media_.attributes.RESOLUTION.height + 'p',
          language: this.options.languages.quality,
        };
      case 'PlaybackRateMenuButton':
        return {
          default: 'Normal',
          language: this.options.languages.speed,
        };
      case 'ChaptersButton':
        return {
          default: '',
          language: this.options.languages.chapters,
        };
      case 'AudioTrackButton':
        let audioTracks = this.player.audioTracks();
        let defaultAudio = this.options.languages.defaultAudio;
        let x = audioTracks.length;

        while (x--) {
          if (audioTracks[x].enabled) {
            defaultAudio = audioTracks[x].label;
          }
        }
        return {
          default: audioTracks.length === 1 ? 'Padrão' : defaultAudio,
          language: this.options.languages.audio,
        };
      case 'SubsCapsButton':
        let captionTracks = this.player.textTracks();

        let defaultCaptions = this.options.languages.captions_off;

        let z = captionTracks.length;

        while (z--) {
          if (captionTracks[z].kind === 'subtitles' && captionTracks[z].mode === 'showing') {
            defaultCaptions = captionTracks[z].label;
          }
        }

        return {
          default: defaultCaptions,
          language: this.options.languages.subtitles,
        };

      default:
        return {
          default: '',
          language: 'Menu',
        };
    }
  }

  removeElementsByClass(className) {
    document.querySelectorAll('.scaleup-sm-top-level').forEach(element => {
      element.classList.remove('vjs-hidden');
    });

    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  cleanDefault(state) {
    state = state.replace(/\s\s+/g, ' ');

    let stateComma = state.indexOf(',');

    state = state.substring(0, stateComma != -1 ? stateComma : state.length);
    state = state.replace(/(<([^>]+)>)/gi, '');
    switch (state) {
      case '1x':
        return (state = 'Normal');
      case 'Auto':
        return (state = this.player.tech(true).vhs.playlists.media_.attributes.RESOLUTION.height + 'p');
      default:
        return state;
    }
  }

  formatBps(bits) {
    let i = -1;

    const byteUnits = [' kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];

    do {
      bits = bits / 1024;
      i++;
    } while (bits > 1024);

    return Math.max(bits, 0.1).toFixed(1) + byteUnits[i];
  }
}

SettingsMenu.defaultState = {};

videojs.registerPlugin('settingsMenu', SettingsMenu);

export default SettingsMenu;
